const countRowsPerPage = () => {
  return ((window?.innerHeight - 340) / 65).toFixed(0)
}

export default countRowsPerPage
